import {Component, EventEmitter, Input, NgModule, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromPhrases from 'projects/journal/src/_selectors/phrases-entity.selector';
import {NgbPopover, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Observable} from 'rxjs';
import {CommonModule} from '@angular/common';
import {TranslocoModule, TranslocoService} from '@ngneat/transloco';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule} from '@angular/forms';
import {IconSpritesModule} from 'shared/lib/icon-sprite/icon-sprite.component';
import {IPhrase} from '../../../../journal/src/_interface/phrases.model';
import {map} from 'rxjs/operators';
import * as fromPhrasesActions from '../../../../journal/src/_actions/phrases.actions';
import {DocumentationPhraseDto} from 'app/_models/model/documentationPhraseDto';

@UntilDestroy()
@Component({
	selector: 'form-phrases-select',
	templateUrl: './phrases-select.component.html',
	styleUrls: ['./phrases-select.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class PhrasesSelectComponent  {
	private addOption: DocumentationPhraseDto = {
		phraseId: null,
		content: null,
		name: this.translate.translate('journal.phrases.addNewItem'),
		templateFieldId: null,
		authorId: null,
		created: null,
		updated: null,
	};
	private tfid: string;
	@ViewChild('p', {static: false}) p: NgbPopover;
	@Input() set templateFieldId(tfid: string) {
		if (!tfid) return;
		this.tfid = tfid;
		this.setPhrases$();
	}
	@Output() phraseSelected: EventEmitter<IPhrase> = new EventEmitter<IPhrase>();
	phrases$: Observable<DocumentationPhraseDto[]>;

	constructor(private store: Store, private translate: TranslocoService) { }
	private setPhrases$ = () => this.phrases$ = this.store.select(fromPhrases.selectPhrasesForTemplateField(this.tfid)).pipe(
		untilDestroyed(this),
		map(ent => this.mapWithAddOptions(ent))
	)

	mapWithAddOptions = (entities: DocumentationPhraseDto[]) => [this.addOption, ...entities];
	compareWithFn = (...[a, b]: IPhrase[]): boolean => a.name === b.name && a.phraseId === b.phraseId;
	open = () => this.p.open();
	close = () => this.p.close();

	edit = ($event: MouseEvent, item: IPhrase) => {
		$event.preventDefault();
		$event.stopPropagation();
		this.close();
		this.store.dispatch(fromPhrasesActions.editPhrase({phraseId: item.phraseId}));
	}

	create = ($event: MouseEvent) => {
		$event.preventDefault();
		this.close();
		this.store.dispatch(fromPhrasesActions.createPhrase({templateFieldId: this.tfid}));
	}

	delete = ($event: MouseEvent, {phraseId}: IPhrase) => {
		$event.preventDefault();
		$event.stopPropagation();
		this.close();
		this.store.dispatch(fromPhrasesActions.tryDeletePhrase({phraseId}));
	}

	select = ($event: MouseEvent, item: IPhrase) => {
		$event.preventDefault();
		this.phraseSelected.emit(item);
	}
}

@NgModule({
	declarations: [PhrasesSelectComponent],
	exports: [
		PhrasesSelectComponent
	],
	imports: [
		CommonModule,
		TranslocoModule,
		NgSelectModule,
		FormsModule,
		NgbPopoverModule,
		IconSpritesModule,
	]
})
export class PhrasesSelectComponentModule {}
